import Backbone from 'backbone';
import Handlebars from 'handlebars';

import EventHub from '~/eventHub';
import Settings from '~/settings.js';
import getUserService from '~/services/userService';
import ProgressService from "~/services/progressService";
import template from '~/templates/firstLogin.handlebars';
import toastr from 'toastr';

var FirstLoginView = Backbone.View.extend({
	className: 'FirstLogin_wrapper',
	userId: null,
	url: null,
	username: null,
	initialize: function() {
		
	},
	
	events: {
		'click .submit': 'login',
	},
	
	render: function() {
		this.attachEvents();
		var handlebarsTemplate = Handlebars.template(template);
		this.$el.html(handlebarsTemplate());
		this.$el.find('.form-control').on('keypress', function(e){
			if(e.key === "Enter") {
				e.preventDefault();
				$('.submit').click();
			}
		});
		this.translate();
		EventHub.trigger('renderTickets');
		return this;
	},
	
	attachEvents: function() {
		var that = this;
		this.listenTo(EventHub, 'firstLogin:setData', data => {
			that.userId = data.id;
			that.url = data.url;
			that.username = data.username;
		});
		setTimeout(function() {
			toastr.error(arrlang[lang]["FirstLoginTimeout"]);
			EventHub.trigger('navigate', 'login', {
				trigger: true
			});
		}, 600000);
	},
	
	translate: function(e){
		if( lang !='es'){
			this.$el.find('.item').each(function(index, element){
				$(this).text(arrlang[lang][$(this).attr("key")]);
			});
			this.$('#pwd').attr("placeholder", arrlang[lang][this.$('#pwd').attr("key")]).blur();
			this.$('#pwd').attr("title", arrlang[lang]["FirstPasswordFieldHover"]);
			this.$('#confirmpwd').attr("placeholder", arrlang[lang][this.$('#pwd').attr("key")]).blur();
			this.$('#confirmpwd').attr("title", arrlang[lang]["FirstConfirmPasswordFieldHover"]);
		}
	},
	
	login: function() {
		var that = this;
		var pswd = this.$('#pwd').val();
		var confirmpswd = this.$('#confirmpwd').val();
		if(pswd != '' && confirmpswd != ''){
			if(pswd != '' && confirmpswd != '' && pswd == confirmpswd){
				var passw = new RegExp(/^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])[\w~@#$%^&*+=`|{}:;!.?\"()\[\]-]{8,24}$/);
				if(pswd.match(passw)) {
					var params = {
						id: this.userId,
						newPassword: pswd
					};
					Parse.Cloud.run("firstLoginChangePassword", params).then(function(result) {
						toastr.success(arrlang[lang]["FirstLoginPswdChangeSuccess"]);
						if(Settings.req2fa){
							getUserService().authorize(that.username, pswd, '').then(() => {
								console.log('Entra');
								var params2 = {
									id: that.userId,
									url: that.url
								}
								EventHub.trigger('navigate', 'req2fauth', {
									trigger: true
								});
								setTimeout(function() {
									EventHub.trigger('req2fauth:setData', params2);
									getUserService().logOut();
								}, 1000);
							},
							(error) => {
								console.log(error);
								ProgressService.decrement();
								EventHub.trigger('navigate', 'login', {
									trigger: true
								});
							});
						}
						else{
							EventHub.trigger('navigate', 'login', {
								trigger: true
							});
						}
					},
					function(error) {
						console.log(error);
						switch(error.code){
							case 100:
								toastr.error(arrlang[lang]['InternetConnectionError'],'Error');
							break;
							default:
								toastr.error(arrlang[lang]['ChnagePasswordError'],'Error');
							break;
						}
					});
				}
				else{
					var $error = this.$(".login-error").html(arrlang[lang]["ValidPassword"]);
					setTimeout(function() {
						$error.html('');
					}, 10000);
				}
			}
			else{
				var $error = this.$(".login-error").html(arrlang[lang]["SamePassword"]);
				setTimeout(function() {
					$error.html('');
				}, 3000);
			}
		}
		else{
			var $error = this.$(".login-error").html(arrlang[lang]["InputAPassword"]);
			setTimeout(function() {
				$error.html('');
			}, 3000);
		}
	},
});
export default FirstLoginView;
